import React,{useContext} from 'react'
import {GlobalLangCtx} from '../../App'
import {skills_file} from '../json_archivies/skills_json';
import './SkillsComp.css'

const SkillsComp = () =>{

    const [globalLan, setGlobalLan] = useContext(GlobalLangCtx)
    const imgPath = './skills_img/';

    const retArray = skills_file.map((el, idx) =>{
      return(
          <div key={idx} className='BlockSkillsEls'>
                  <div className="title_skills">
                      {el.name}
                  </div>
                  <div className="img_skills">
                    <div className='BoxImgSkills'>
                        <img src={imgPath + el.img} alt="" />
                    </div>
                  </div>
                  <div className="rating_skills">
                      <span>Rating: </span>{el.rating} / 10
                  </div>
          </div>
      )
    })

    return (
        <section id='skillsComp'>
            <div>
                <h1>
                    Skills
                </h1>
            </div>
            <div className='skillsMainBox'>
                <div className='skillBox'>
                    { retArray }
                </div>
            </div>
        </section>
    )
}


export default SkillsComp;